module.exports = __webpack_public_path__ + "static/media/happy_christmas_important.d3f01fb9.svg";